<template>
    <div class="sendMsg">
        <span @click="openMsg_MSG">发送消息</span>
        <span @click="openMsg_CQ">发送通播</span>
        <span @click="openMsg_CM">发送组播</span>
        <span @click="openMsg_POS">点名定位</span>
        <span @click="openMsg_Audio">发送语音</span>
        <span @click="openMsg_IMG">发送图片</span>
    </div>
</template>
<script>
import sendPageMSG from "./sendPageMSG.vue"
import sendPageCQ from "./sendPageCQ.vue"
import sendPageCM from "./sendPageCM.vue"
import sendPagePOS from "./sendPagePOS.vue"
import sendPageIMG from "./sendPageIMG.vue"
import sendPageAudio from "./sendPageAudio.vue"
export default {
    props: ["subData"],
    data() {
        return {
        };
    },
    methods: {
        closeMsg() {
            if (window.rightIns) {
                this.$dialog.close(window.rightIns);
                window.rightIns = undefined;
            }
        },
        openMsg_Audio() {
            this.closeMsg();
            this.$dialog.open({
                title: "发送语音",
                theme: "feature-dialog",
                shade: true,
                area: {
                    height: "600px",
                    width: "680px",
                },
                location: {
                    top: "100px",
                },
                content: {
                    type: "vue",
                    subCom: sendPageAudio,
                    subData: this.subData
                },
            });
        },
        //发送点名定位标识
        openMsg_POS() {
            this.closeMsg();
            this.$dialog.open({
                title: "点名定位",
                theme: "feature-dialog",
                shade: true,
                area: {
                    height: "180px",
                    width: "680px",
                },
                location: {
                    top: "100px",
                },
                content: {
                    type: "vue",
                    subCom: sendPagePOS,
                    subData: this.subData
                },
            });
        },
        //历史图片
        openMsg_IMG() {
            this.closeMsg();
            this.$dialog.open({
                title: "发送图片",
                theme: "feature-dialog",
                shade: true,
                area: {
                    height: "600px",
                    width: "680px",
                },
                location: {
                    top: "100px",
                },
                content: {
                    type: "vue",
                    subCom: sendPageIMG,
                    subData: this.subData
                },
            });
        },
        openMsg_MSG() {
            this.closeMsg();
            this.$dialog.open({
                title: "发送消息",
                theme: "feature-dialog",
                shade: true,
                area: {
                    height: "240px",
                    width: "680px",
                },
                // location: {
                //     top: "100px",
                // },
                content: {
                    type: "vue",
                    subCom: sendPageMSG,
                    subData: this.subData
                },
            });
        },
        //通播
        openMsg_CQ() {
            this.closeMsg();
            this.$dialog.open({
                title: "发送通播",
                theme: "feature-dialog",
                shade: true,
                area: {
                    height: "240px",
                    width: "680px",
                },
                // location: {
                //     top: "100px",
                // },
                content: {
                    type: "vue",
                    subCom: sendPageCQ,
                    subData: this.subData
                },
            });
        },

        //组播-multicast address
        openMsg_CM() {
            this.closeMsg();
            this.$dialog.open({
                title: "发送组播",
                theme: "feature-dialog",
                shade: true,
                area: {
                    height: "300px",
                    width: "680px",
                },
                // location: {
                //     top: "100px",
                // },
                content: {
                    type: "vue",
                    subCom: sendPageCM,
                    subData: this.subData
                },
            });
        }
    }
}
</script>
    
<style scoped lang="scss">
.sendMsg {
    padding: 8px 10px;
    display: flex;
    flex-direction: column;

    span {
        color: #303133;
        cursor: pointer;
        font-size: 14px;
        border-bottom: #E4E7ED solid 1px;
        margin: 2px 0;
        padding-bottom: 2px;

        &:hover {
            color: #1da373;
        }
    }
}
</style>